import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors, utility } = useTheme();

  return {
    text: (hasText, inline) => css`
      color: ${colors.white};
      text-align: center;
      letter-spacing: 0.0013em;
      font-size: 1.5rem;
      ${!hasText && utility.checkboxHidden}

      &:focus {
        outline: none;
      }

      ${hasText &&
      inline &&
      css`
        text-align: center;
        font-weight: 400;
        width: 190px;
      `}

      ${breakpoints.l} {
        letter-spacing: 0.0013em;
        font-size: 1.5rem;
      }
    `,
    loaderCircle: (isSmall) => css`
      -webkit-animation: 1s spin linear infinite;
      animation: 1s spin linear infinite;

      /* Apply your specific small styles */
      ${isSmall && css`
        & > img {
          width: 1.5rem !important;
          height: 1.5rem !important;
        }
      `}

      -webkit-@keyframes spin {
        -webkit-from {
          -webkit-transform: rotate(0deg);
          -ms-transform: rotate(0deg);
          transform: rotate(0deg);
        }
        -webkit-to {
          -webkit-transform: rotate(360deg);
          -ms-transform: rotate(360deg);
          transform: rotate(360deg);
        }
      }

      @-webkit-keyframes spin {
        from {
          -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
        }
        to {
          -webkit-transform: rotate(360deg);
          transform: rotate(360deg);
        }
      }

      @keyframes spin {
        from {
          -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
        }
        to {
          -webkit-transform: rotate(360deg);
          transform: rotate(360deg);
        }
      }
    `,
    logoImage: (isSmall) => css`
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      & > img {
        width: 2.87rem;
        height: 3.44rem;
      }
      /* Apply your specific small styles */
      ${isSmall && css`
        & > img {
          width: 1rem !important;
          height: 1rem !important;
        }
      `}  
    `,
    loaderDiv: css`
      position: relative;
      margin-bottom: 1rem;
      display: flex;
      justify-content: center;
      align-items: center;
    `,
  };
};
